module.exports = ".grid {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 50% 50%;\n      grid-template-columns: 50% 50%; }\n  .grid div {\n    margin: 5px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/exam-preparation/assignment-pvb/signing/signing.component.scss
// module id = ./src/app/exam-preparation/assignment-pvb/signing/signing.component.scss
// module chunks = main